// extracted by mini-css-extract-plugin
module.exports = {"messageBox":"PostCommentFormClosed-messageBox-k9Z_H"};